import { Tracking } from '@/Domain/Tracking/Tracking'
import { TrackingRepository } from '@/Domain/Tracking/TrackingRepository'
import { Orde, Fase, Mountain, Owner, Surface, Taxes, IsolatesMode, Location } from '@/Domain/Tracking/'
import { Lumberjack, NameLumberJack, Ofert, State } from '@/Domain/Tracking/Lumberjacks/'
import { BatchId } from '@/Domain/Batch/BatchId'
import { AccountId } from '@/Domain/Account'

const createTracking = () => {
  return (
    [
      new Tracking(
        new Orde(1),
        new BatchId('019/20', '360076510001'),
        new Fase('Adxudicado provisionalmente'),
        new IsolatesMode('A resultas'),
        new Mountain('MONTE PINDO'),
        new Owner('SERRA E PICATO'),
        new Location('Outes'),
        new Surface('2.85'),
        new Taxes('21.026,77'),
        [
          new Lumberjack(
            new NameLumberJack('AVELINO ARAUJO E HIJOS'),
            new AccountId('10359490Z'),
            new Ofert(3570.00),
            new State('Adxudicado provisionalmente')
          ),
          new Lumberjack(
            new NameLumberJack('LANGAÑO E HIJOS'),
            new AccountId('10359490Z'),
            new Ofert(2410.00),
            new State('Oferta Rechazada')
          )
        ]
      )
    ]
  )
}

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

export class InMemoryTrackingRepository implements TrackingRepository {
  // eslint-disable-next-line
  async fetchTrackingBatches (procedureId: string): Promise<Tracking[]> {
    const duration = 300
    await wait(duration)
    const reviews = createTracking()
    return reviews
  }
}
